import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f08ddcb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "title-label" }
const _hoisted_3 = { class: "radio-padding" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_radio = _resolveComponent("app-radio")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      as: "el-form",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$localize('registration.healthcare.question')), 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_app_radio, {
              class: "app-form-control",
              name: "option",
              value: true,
              previousValue: _ctx.hippaValue,
              modelValue: _ctx.hippaValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.hippaValue) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$localize('registration.healthcare.optionYes')), 1)
              ]),
              _: 1
            }, 8, ["previousValue", "modelValue"]),
            _createVNode(_component_app_radio, {
              class: "app-form-control",
              name: "option",
              value: false,
              previousValue: _ctx.hippaValue,
              modelValue: _ctx.hippaValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.hippaValue) = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$localize('registration.healthcare.optionNo')), 1)
              ]),
              _: 1
            }, 8, ["previousValue", "modelValue"])
          ])
        ]),
        _createVNode(_component_app_button, {
          type: "primary",
          "native-type": "submit",
          class: "w-100 el-button-lg",
          round: "",
          disabled: _ctx.hippaValue === undefined,
          onClick: _ctx.nextStep
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$localize('registration.button.next')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _: 1
    })
  ]))
}